export interface IVoiceStunServers {
    sessionId: string;
    isSuccess: boolean;
    data: IVoiceStunServerData[];
}

export interface IVoiceStunServerData {
    dataValue: string;
}

export const DefaultVoiceStunServers: IVoiceStunServers = {
    sessionId: '',
    isSuccess: false,
    data: [],
};
